import { Shield } from 'lucide-react'

export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-10">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4 flex items-center gap-3">
          <Shield className="w-8 h-8 text-primary-600" aria-hidden="true" />
          Privacy Policy
        </h1>
        <p className="text-lg text-slate-600">
          This is a client-side tool. We do not collect, store, or transmit your salary, inputs, or results.
        </p>
      </div>

      <section className="mb-10">
        <h2 className="text-xl font-semibold text-slate-900 mb-4">What we do not collect</h2>
        <div className="card p-6 text-slate-700">
          <ul className="list-disc list-inside space-y-2">
            <li>Salary figures, hourly rates, or any calculator inputs.</li>
            <li>Personally identifiable information such as name, email, or location.</li>
            <li>Results, exports, or generated reports.</li>
            <li>Server-side logs of your calculations.</li>
          </ul>
          <p className="mt-4">
            All calculations run in your browser. Leaving the page clears the calculation state.
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold text-slate-900 mb-4">What we do process</h2>
        <div className="card p-6 text-slate-700">
          <p>
            The site uses Netlify&apos;s standard hosting infrastructure. Netlify may log IP addresses,
            request URLs, and timestamps for security and reliability purposes in accordance with their
            privacy policy. We do not have access to individual calculator inputs from those logs.
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold text-slate-900 mb-4">If we add analytics or email capture</h2>
        <div className="card p-6 text-slate-700">
          <p>
            If we add analytics, email capture, or any server-side feature, we will:
          </p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Display a cookie consent banner for visitors from jurisdictions that require it.</li>
            <li>Require an explicit opt-in before sending marketing emails.</li>
            <li>Never store raw salary or other sensitive financial inputs server-side.</li>
            <li>Provide a clear data deletion request mechanism.</li>
            <li>Update this privacy policy before collecting any new data.</li>
          </ul>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold text-slate-900 mb-4">Contact</h2>
        <div className="card p-6 text-slate-700">
          <p>
            For privacy questions or data-deletion requests, contact us through the site or at the email
            listed on the homepage. This policy may be updated as the site evolves.
          </p>
        </div>
      </section>
    </div>
  )
}
